import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { List, Modal, Space } from "antd"
import { NavigationService } from "../../services/navigationService"
import useServiceTicketsEnabled from "../../hooks/useServiceTicketsEnabled"
import { buildAddNewItems, COLUMN_COUNT, isBlank, isHeader, isLink } from "./addNewModalModel"

export type Props = {
  open: boolean
  onClose: () => void
  navigationService: NavigationService
}

const AddNewModal = ({ open, onClose, navigationService }: Props) => {
  const items = buildAddNewItems(useServiceTicketsEnabled())

  const handleClick = (url: string) => {
    onClose()
    const [targetPage, hash] = url.split('#')
    if (navigationService.path === `/${targetPage}`) {
      navigationService.setHash(hash)
    } else {
      navigationService.setUrl(url)
    }
  }

  return <Modal
    title="Add New"
    open={open}
    width={600}
    onCancel={onClose}
    footer={[]}
  >
    <List
      grid={{ gutter: 24, column: COLUMN_COUNT }}
      dataSource={items}
      renderItem={item => {
        return <List.Item>
          {isHeader(item) && <strong>{item.label}</strong>}
          {isLink(item) && <a onClick={() => handleClick(item.url)}>
            <Space align="start">
              <FontAwesomeIcon icon={item.icon} />
              {item.label}
            </Space>
          </a>}
          {isBlank(item) && <></>}
        </List.Item>
      }}
    />
  </Modal>
}

export default AddNewModal
